<template lang="html">
  <div class="row col-xs middle-xs top-bar-data">
    <div class="items-center top-bar-data-style">
      <div class="display-data">
        <div>
          Upgrade Code:
          <i
            v-my-tooltip="upgradeCodeTooltip"
            class="fa fa-info-circle"
            style="color: #848484"
            aria-hidden="true"
          />
        </div>
        <div class="b school-data-style">{{ upgradeCode }}</div>
      </div>
      <div class="display-data">
        <div>
          License Details:
          <i
            v-my-tooltip="licenseDetailsTooltip"
            class="fa fa-info-circle"
            style="color: #848484"
            aria-hidden="true"
          />
        </div>
        <div class="b school-data-style">{{ licenseDetailsDisplay }}</div>
      </div>
      <div class="display-data">
        <Tooltip
          :text="licensesUsedTooltip"
          styleTooltip=""
        >
          <button>
            Licenses Used:<i class="fa ml-1 fa-info-circle" style="color: #848484" aria-hidden="true"/>
          </button>
        </Tooltip>
        <!-- <div>
          Licenses Used:
          <i v-my-tooltip="licensesUsedTooltip" class="fa fa-info-circle" style="color: #848484" aria-hidden="true"/>
        </div> -->
        <div class="b school-data-style" v-if="licensesUsedDisplay">
          {{ licensesUsedDisplay }}
        </div>
        <div
          class="b school-data-style"
          v-else-if="!licensesUsedDisplay && licenseDetailsDisplay"
        >
          0
        </div>
      </div>
      <div class="display-data">
        <div>
          Expiration:
          <i
            v-my-tooltip="expirationDateTooltip"
            class="fa fa-info-circle"
            style="color: #848484"
            aria-hidden="true"
          />
        </div>
        <div class="b school-data-style">{{ expirationDate }}</div>
      </div>
    </div>
    <div
      v-if="hasAdminAdminPermission"
      class="col-xs add-new-users-style"
      style="padding: 0"
    >
      <!-- Just add when have SIS integrations -->
      <!-- <div>
        Auto-sync is on
        <i
          v-my-tooltip="addNewUsersTooltip"
          class="fa fa-info-circle"
          style="color: #848484;"
          aria-hidden="true"
        />
      </div> -->
      <button
        class="px-8 py-2 rounded cursor-pointer bg-primary text-white text-sm font-semibold disabled:opacity-50"
        style="margin-left: 0px"
        @click="goToAddUsers"
      >
        ADD NEW USERS
      </button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import moment from 'moment';
  import { EventBus } from 'utils/event-bus';
  export default {
    data() {
      return {};
    },
    props: {
      licenseDetails: {
        type: Number,
        default: null,
      },
      licensesUsed: {
        type: Number,
        default: null,
      },
    },
    components: {
      Tooltip: () => import('../../../../components/Tooltip.vue')
    },
    computed: {
      ...mapGetters([
        'getProfile',
        'getCurrentSchool',
        'hasAdminAdminPermission',
      ]),
      upgradeCode() {
        if (
          this.getCurrentSchool &&
          this.getCurrentSchool.invites &&
          this.getCurrentSchool.invites.length > 0 &&
          this.getCurrentSchool.invites[0].code
        ) {
          return this.getCurrentSchool.invites[0].code;
        } else {
          return null;
        }
      },
      licenseDetailsDisplay() {
        if (
          this.getCurrentSchool &&
          this.getCurrentSchool.membership &&
          this.getCurrentSchool.membership.length > 0 &&
          this.getCurrentSchool.membership[0].school_membership &&
          this.getCurrentSchool.membership[0].school_membership
            .number_of_licenses
        ) {
          return (
            this.getCurrentSchool.membership[0].school_membership
              .number_of_licenses +
            ' ' +
            this.getCurrentSchool.membership[0].school_membership
              .membership_type +
            's'
          );
        } else {
          return null;
        }
      },
      licensesUsedDisplay() {
        if (
          this.getCurrentSchool &&
          this.getCurrentSchool.membership &&
          this.getCurrentSchool.membership.length > 0 &&
          this.getCurrentSchool.membership[0].school_membership &&
          this.getCurrentSchool.membership[0].school_membership.licenses_used
        ) {
          return (
            this.getCurrentSchool.membership[0].school_membership
              .licenses_used +
            ' ' +
            this.getCurrentSchool.membership[0].school_membership
              .membership_type +
            's'
          );
        } else {
          return null;
        }
      },
      expirationDate() {
        if (
          this.getCurrentSchool &&
          this.getCurrentSchool.membership &&
          this.getCurrentSchool.membership.length > 0 &&
          this.getCurrentSchool.membership[0].school_membership &&
          this.getCurrentSchool.membership[0].school_membership.end_date
        ) {
          const date = new Date(
            this.getCurrentSchool.membership[0].school_membership.end_date
          );
          return date ? moment(date).format('MM-DD-YYYY') : '';
        } else {
          return null;
        }
      },
      upgradeCodeTooltip() {
        return 'Share this code with teachers who have free trial Parlay accounts. They can use it to upgrade their account by connecting with the school account.';
      },
      licenseDetailsTooltip() {
        if (
          this.getCurrentSchool &&
          this.getCurrentSchool.membership &&
          this.getCurrentSchool.membership.length > 0 &&
          this.getCurrentSchool.membership[0].school_membership
            .membership_type === 'teacher'
        ) {
          return 'This is the total number of teacher licenses the school / district has purchased for Parlay. This is the maximum number of teachers you can connect to the organization.';
        } else {
          return 'This is the total number of student licenses the school / district has purchased for Parlay. You can go over this.';
        }
      },
      licensesUsedTooltip() {
        if (this.getCurrentSchool && this.getCurrentSchool.membership && this.getCurrentSchool.membership.length > 0 && this.getCurrentSchool.membership[0].school_membership.membership_type === 'teacher') {
          return 'This is the current number of teacher accounts who are connected to the school with an upgraded account.';
        } else {
          return 'This is the cumulative number of student accounts that have been associated with the school / district over time. To see the number of active students from this school year, see the Analytics tab.';
        }
      },
      expirationDateTooltip() {
        return 'This is the date that the current license ends.';
      },
      addNewUsersTooltip() {
        return 'Add New Users Tooltip';
      },
    },
    methods: {
      goToAddUsers() {
        this.$router.push({ name: 'admin-add-users' });
        EventBus.$emit('reloadAddUsers');
      },
    },
    created() {},
    mounted() {},
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .top-bar-data {
    display: flex;
    padding-bottom: 10px;
  }

  .top-bar-data-style{
    height: 68px;
    display: flex;
    background-color: #E5EEFC;
  }

  .display-data{
    padding-right:20px;
    padding-left:20px;
  }

  .add-new-users-style{
    @media only screen and (min-width: 1070px)   {
      margin-left: 40px;
    }

    @media only screen and (min-width: 885px) and (max-width: 1020px)   {
      margin-left: 40px;
    }
  }

  .school-data-style{
    font-size:20px;
  }
</style>



// WEBPACK FOOTER //
// adminPortalUsersTopBar.vue?196d700a